import {
    BadGateway,
    BadRequest,
    Forbidden,
    GatewayTimeout,
    InternalServerError,
    MethodNotAllowed,
    NotFound,
    NotImplemented,
    ServiceUnavailable,
    Unauthorized,
} from "@figurepos/fgr-lib-business-logic/lib/http/errors"
import {
    createHttpRequest as createHttpRequestLib,
    encodeUrlParameters,
    HttpRequest,
} from "@figurepos/fgr-lib-business-logic/lib/http/httpRequests"
import fetch from "isomorphic-fetch"
import { any, includes } from "ramda"
import { getApiKey } from "../../utils/apiKeys"
import { Config } from "../../utils/config"

export const createHttpRequest = async (request: HttpRequest): Promise<any> => {
    const url: string = encodeUrlParameters(
        request.baseUrl || Config.webApiBaseUrl,
        request.path || "",
        request.parameters || {}
    )
    const result = await createHttpRequestLib(fetch, {
        ...request,
        headers: {
            ...request.headers,
            "figure-api-key": getApiKey(),
        },
        url: url,
    })
    return result
}

export type GraphQLHttpRequest = {
    headers: Record<string, any>
    body: Record<string, any>
}

const isError = (errors, status: number): boolean =>
    any(
        // @ts-expect-error
        msg => includes(`${status}`, msg),
        errors.map(e => e.message)
    )

const isAuthError = (errors): boolean =>
    any(
        // @ts-expect-error
        extension => extension && extension.code === "UNAUTHENTICATED",
        errors.map(e => e.extensions)
    )

export const createGraphQLRequest = (request: GraphQLHttpRequest): Promise<any> =>
    createHttpRequest({
        method: "POST",
        baseUrl: Config.graphqlBaseUrl,
        body: request.body,
        headers: {
            "Content-Type": "application/json",
            "figure-api-key": getApiKey(),
            ...request.headers,
        },
    }).then(resp => {
        if (resp && resp.errors && Array.isArray(resp.errors)) {
            if (isError(resp.errors, 400)) {
                throw new BadRequest(resp)
            }

            if (isAuthError(resp.errors)) {
                // 401
                throw new Unauthorized(resp)
            }

            if (isAuthError(resp.errors)) {
                // 403
                throw new Forbidden(resp)
            }

            if (isError(resp.errors, 404)) {
                throw new NotFound(resp)
            }

            if (isError(resp.errors, 405)) {
                throw new MethodNotAllowed(resp)
            }

            if (isError(resp.errors, 500)) {
                throw new InternalServerError(resp)
            }

            if (isError(resp.errors, 501)) {
                throw new NotImplemented(resp)
            }

            if (isError(resp.errors, 502)) {
                throw new BadGateway(resp)
            }

            if (isError(resp.errors, 503)) {
                throw new ServiceUnavailable(resp)
            }

            if (isError(resp.errors, 504)) {
                throw new GatewayTimeout(resp)
            }

            throw Error(JSON.stringify(resp.errors))
        }

        return resp
    })
